module.exports = __WEBPACK_EXTERNAL_MODULE_183__;


//////////////////
// WEBPACK FOOTER
// external "core-js/modules/es6.array.reduce"
// module id = 183
// module chunks = 0